var e;(o=>{function i(){let r="6.28.0";return r}o.sdkVersion=i;})(e||(e={}));

export { e as a };
